import AppService from '../shared/App.api';
import { taskFromAPI, taskToAPI } from './Task.model';

const tasksEndpoint = '/admin/tasks';

export default {
  getTasks,
  getTaskById,
  getReach,
  createTask,
  updateTask,
  endTask,
  deleteTask,
};

async function getTasks() {
  const response = await AppService.get(tasksEndpoint);
  return (response.data || []).map(taskFromAPI);
}

async function getTaskById(taskId) {
  const response = await AppService.get(`${tasksEndpoint}/${taskId}`);
  return taskFromAPI(response.data);
}

// apiTargeting is the API-shaped targeting object (targetingToAPI output).
async function getReach(apiTargeting) {
  const response = await AppService.postJson(
    `${tasksEndpoint}/reach`,
    apiTargeting || {}
  );
  return response.data;
}

async function createTask(task) {
  const response = await AppService.postJson(tasksEndpoint, taskToAPI(task));
  return taskFromAPI(response.data);
}

async function updateTask(taskId, task) {
  const response = await AppService.put(
    `${tasksEndpoint}/${taskId}`,
    taskToAPI(task)
  );
  return taskFromAPI(response.data);
}

async function endTask(taskId) {
  await AppService.put(`${tasksEndpoint}/${taskId}/end`);
}

async function deleteTask(taskId) {
  await AppService.deleteCall(`${tasksEndpoint}/${taskId}`);
}
